export var CHART_COLORS = ['#D4A843', '#3B82F6', '#10B981', '#8B5CF6', '#EF4444', '#F59E0B'];

export var STATUS_COLORS = {
  held: { bg: '#EFF6FF', text: '#1D4ED8', dot: '#3B82F6' },
  released: { bg: '#ECFDF5', text: '#047857', dot: '#10B981' },
  disputed: { bg: '#FEF2F2', text: '#B91C1C', dot: '#EF4444' },
  refunded: { bg: '#F3F4F6', text: '#374151', dot: '#6B7280' },
  partial_refund: { bg: '#FFFBEB', text: '#92400E', dot: '#F59E0B' },
  payout_failed: { bg: '#FEF2F2', text: '#B91C1C', dot: '#EF4444' },
  mixed: { bg: '#FEF3C7', text: '#92400E', dot: '#F59E0B' },
  uncaptured: { bg: '#F3E8FF', text: '#6B21A8', dot: '#8B5CF6' },
};

export function formatNum(n) {
  if (n === undefined || n === null) return '0';
  var num = Number(n);
  if (isNaN(num)) return '0';
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return num.toFixed(2);
}

export function formatDate(d) {
  if (!d) return '';
  var date = new Date(d);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
